import { useAppSelector } from '@/store/hooks'

export const useGetCourseCoverColor = (aggregateId: string) => {
  const backgroundMap = useAppSelector((store) => store.aggregates.backgroundMap)
  return backgroundMap[aggregateId]
}
